import React, { useState } from 'react';
import { useMetadata } from '../../context/MetadataContext'; 
import { useGameState } from '../../context/GameStateContext';
import { useGlobalError } from '../../context/GlobalErrorContext';
import NewPuzzle from '../NewPuzzle';
import CreatedPuzzles from '../CreatedPuzzles';
import styles from './CreateFind.module.css';
import { Database, Plus } from 'lucide-react';

const CreateFind = () => {
  const [showNewPuzzleModal, setShowNewPuzzleModal] = useState(false);
  const [showCreatedPuzzlesModal, setShowCreatedPuzzlesModal] = useState(false);
  const { getText } = useMetadata();
  const { gameData } = useGameState();
  const { triggerError } = useGlobalError();

  if (gameData?.state) {
    triggerError('high', 'CreateFind component rendered when puzzle already selected. This indicates a routing/status determination error.');
    return null;
  }

  const handleNewPuzzle = () => {
    setShowNewPuzzleModal(true);
  };

  const handleCreatedPuzzles = () => {
    setShowCreatedPuzzlesModal(true);
  };

  const handleCloseNewPuzzle = () => {
    setShowNewPuzzleModal(false);
  };

  const handleCloseCreatedPuzzles = () => {
    setShowCreatedPuzzlesModal(false);
  };

  return (
    <div className="dataContainer">
      <div className="containerHeader">
        <h2>{getText('create.title')}</h2>
      </div>
      <div className="dataContent">
        <div className="contentGroup">       
          <div className="groupHeader">
            <h3>{getText('create.how_title')}</h3>
          </div>
          
          <div className="groupDescription">
            {getText('create.description')}
          </div>
        </div>


      </div>
      <div className="actionButtonContainer">
      <button 
          className="iconButton primaryButton"
          onClick={handleCreatedPuzzles}
          title={getText('create.title')}
          aria-label={getText('create.title')}
        >
          <Database className="buttonIcon" />
        </button>

      <button 
          className="iconButton primaryButton"
          onClick={handleNewPuzzle}
          title={getText('create.new_puzzle')}
          aria-label={getText('create.new_puzzle')}
        >
          <Plus className="buttonIcon" />
        </button>
      </div>


      {/* Modals */}
      <NewPuzzle 
        isOpen={showNewPuzzleModal} 
        onClose={handleCloseNewPuzzle} 
      />
      <CreatedPuzzles 
        isOpen={showCreatedPuzzlesModal} 
        onClose={handleCloseCreatedPuzzles} 
      />
    </div>
  );
};

export default CreateFind;